import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Box,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

interface UserFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (users: { email: string; endDate: string }[]) => void;
  loading: boolean;
  accountsQuanty: number;
}

const UserForm: React.FC<UserFormProps> = ({
  open,
  onClose,
  onSubmit,
  loading,
  accountsQuanty,
}) => {
  const [users, setUsers] = useState<{ email: string; endDate: string }[]>([
    { email: "", endDate: "" },
  ]);

  const handleAddInput = () => {
    if (users.length < accountsQuanty) {
      setUsers([...users, { email: "", endDate: "" }]);
    }
  };

  const handleRemoveInput = (index: number) => {
    const updatedUsers = users.filter((_, i) => i !== index);
    setUsers(updatedUsers);
  };

  const handleChange = (
    index: number,
    field: "email" | "endDate",
    value: string
  ) => {
    const updatedUsers = [...users];
    updatedUsers[index][field] = value;
    setUsers(updatedUsers);
  };

  const handleSubmit = () => {
    const filteredUsers = users.filter(
      (user) => user.email.trim() !== "" && user.endDate.trim() !== ""
    ); // Убираем пустые записи
    onSubmit(filteredUsers);
    setUsers([{ email: "", endDate: "" }]); // Сбрасываем форму
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Users</DialogTitle>
      <DialogContent>
        {users.map((user, index) => (
          <Box key={index} marginBottom={2}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <TextField
                  label={`Email ${index + 1}`}
                  variant="outlined"
                  fullWidth
                  value={user.email}
                  onChange={(e) => handleChange(index, "email", e.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  label="End Date"
                  variant="outlined"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={user.endDate}
                  onChange={(e) =>
                    handleChange(index, "endDate", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <IconButton
                  onClick={() => handleRemoveInput(index)}
                  disabled={users.length === 1}
                  color="error"
                >
                  <RemoveIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
        ))}
        {users.length < accountsQuanty && (
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleAddInput}
            sx={{ marginTop: 2 }}
          >
            Add User
          </Button>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Adding..." : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserForm;
